/**
 * 班课api
 * 班课相关界面api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ClazzCourseSummaryVo from './ClazzCourseSummaryVo';
import GroupedStatisticsVo from './GroupedStatisticsVo';
import IdNameVo from './IdNameVo';
import SerialNameVo from './SerialNameVo';
import StatisticsItemVo from './StatisticsItemVo';
import TextBookVo from './TextBookVo';




  /**
   * The TextbookStatisticsVo model module.
   * @module clazz_course/model/TextbookStatisticsVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextbookStatisticsVo</code>.
   * @alias module:clazz_course/model/TextbookStatisticsVo
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>TextbookStatisticsVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:clazz_course/model/TextbookStatisticsVo} obj Optional instance to populate.
   * @return {module:clazz_course/model/TextbookStatisticsVo} The populated <code>TextbookStatisticsVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'clazzCourse')) {
        obj['clazzCourse'] = ClazzCourseSummaryVo.constructFromObject(data['clazzCourse']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbook')) {
        obj['textbook'] = TextBookVo.constructFromObject(data['textbook']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'unit')) {
        obj['unit'] = SerialNameVo.constructFromObject(data['unit']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'textbookList')) {
        obj['textbookList'] = ApiClient.convertToType(data['textbookList'], [IdNameVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'statistics')) {
        obj['statistics'] = ApiClient.convertToType(data['statistics'], [StatisticsItemVo]);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'groupedStatistics')) {
        obj['groupedStatistics'] = ApiClient.convertToType(data['groupedStatistics'], [GroupedStatisticsVo]);
      }
    }
    return obj;
  }

  /**
   * 当前班课
   * @member {module:clazz_course/model/ClazzCourseSummaryVo} clazzCourse
   */
  exports.prototype['clazzCourse'] = undefined;
  /**
   * 当前教材
   * @member {module:clazz_course/model/TextBookVo} textbook
   */
  exports.prototype['textbook'] = undefined;
  /**
   * 当前单元
   * @member {module:clazz_course/model/SerialNameVo} unit
   */
  exports.prototype['unit'] = undefined;
  /**
   * @member {Array.<module:clazz_course/model/IdNameVo>} textbookList
   */
  exports.prototype['textbookList'] = undefined;
  /**
   * 总体统计
   * @member {Array.<module:clazz_course/model/StatisticsItemVo>} statistics
   */
  exports.prototype['statistics'] = undefined;
  /**
   * 分组(unit或lesson）统计
   * @member {Array.<module:clazz_course/model/GroupedStatisticsVo>} groupedStatistics
   */
  exports.prototype['groupedStatistics'] = undefined;



  export default exports;
;


